import { render, staticRenderFns } from "./AutoCheckBatchSummary.vue?vue&type=template&id=617a4ac5&scoped=true&"
import script from "./AutoCheckBatchSummary.vue?vue&type=script&lang=js&"
export * from "./AutoCheckBatchSummary.vue?vue&type=script&lang=js&"
import style0 from "./AutoCheckBatchSummary.vue?vue&type=style&index=0&id=617a4ac5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a4ac5",
  null
  
)

export default component.exports